module.exports = __webpack_public_path__ + "media/movimentar_encomenda.3538bcc8.mp4";